export const ImportDataHeader = [
  {
    label: "Shipto",
    key: "customer_account_number",
  },
 
  {
    label: "Deactivation Date(MM/DD/YYYY)",
    key: "signature_end_date",
  }
  
];
export const exporDatatHeaders = [
  {
    label: "Member ID",
    key: "loyalty_id",
  },
  {
    label: "Shipto",
    key: "customer_account_number",
  },
  {
    label: "Billto",
    key: "customer_billto_account_number",
  },
  {
    label: "Shipto Name",
    key: "customer_name",
  },
  {
    label: "Service Plus Status",
    key: "service_plus_flag",
  },

  {
    label:"Tier Level",
    key: "tier_service_agreement",
  }

];